import { createReduxHistoryContext } from 'redux-first-history';
import { createMemoryHistory } from 'history';

const { createReduxHistory, routerMiddleware, routerReducer } = createReduxHistoryContext({
  history: createMemoryHistory()
});

export { createReduxHistory, routerMiddleware, routerReducer };
